import {ChangeDetectionStrategy, Component, Input} from '@angular/core';
import {CatalogRecord} from '@store/catalog/catalog.types';
import {CoverAndDetailsColumnComponent} from '@app/catalog/search/table-column-components/cover-and-details-column.component';
import {AvailabilityColumnComponent} from '@app/catalog/search/table-column-components/availability-column.component';

@Component({
  selector: 'px-catalog-search-cover-details-availability-column',
  host: {
    class: 'w-full'
  },
  templateUrl: './combined-cover-details-availability-column.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CoverAndDetailsColumnComponent, AvailabilityColumnComponent]
})
export class CombinedCoverDetailsAvailabilityColumnComponent {
  @Input({required: true}) public catalogRecord: CatalogRecord;
}
